import AggregateProto from './aggregate-proto'

export default class AggregateNumber extends AggregateProto {

    constructor(dataArray: any[]) {
        super(dataArray)

        const normalizedData : number[] = []
        _.map(this.data, (value:any)=>{
            const normalizedValue = _.toNumber(value)
            if (normalizedValue || normalizedValue === 0) {
                normalizedData.push(normalizedValue)
            }
        })

        this.data = normalizedData
    }

    min() {return _.min(this.data)}
    max() {return _.max(this.data)}

    median() {
        const array = _.sortBy(this.data);
        if (array.length % 2 === 0) {
            // for even number elements take two values in center and divide in two
            return (array[array.length / 2] + array[(array.length / 2) - 1]) / 2;
        } else {
            // for odd number elements take value in center
            return array[(array.length - 1) / 2];
        }
    }

    sum() {
        return _.sum(this.data)
    }
    average() {return _.mean(this.data)}
}